import { llmFetchUrl, llmFetcher } from './fetchers';

export async function getSession() {
  const response = await llmFetcher.post(llmFetchUrl.sessionUrl);
  return response.data;
}

export async function getAnswer(query: string, session_id: string) {
  const response = await llmFetcher.post(llmFetchUrl.getAnswer, {
    query,
    session_id,
  });
  return response.data;
}
